import {
  RETRIEVAL_GUARDIAN_BOND,
} from "../guardianFormConfig";
import {
  GoogleAutoComplete,
  LabeledCreatableSelect,
  splitEmploymentOccupation,
  joinEmploymentOccupation,
} from "./GuardianshipBondRetrieveHelpers";
import RetrievalGuardianFormBase from "./RetrievalGuardianFormBase";

export default function GuardianshipGuardianForm(props) {
  return (
    <RetrievalGuardianFormBase
      bondKind={RETRIEVAL_GUARDIAN_BOND.guardianship}
      GoogleAutoComplete={GoogleAutoComplete}
      LabeledCreatableSelect={LabeledCreatableSelect}
      splitEmploymentOccupation={splitEmploymentOccupation}
      joinEmploymentOccupation={joinEmploymentOccupation}
      {...props}
    />
  );
}
